import Checkbox from './Checkbox.vue';
import CheckboxGroup from './CheckboxGroup.vue';
import InlineSelect from './InlineSelect.vue';

export default [
  Checkbox,
  CheckboxGroup,
  InlineSelect,
];
